// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@rexlabs/plz-cli/node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReactTable .rt-thead .rt-th.-cursor-pointer, .ReactTable .rt-thead .rt-td.-cursor-pointer {\n    border: none !important;\n}\n\n.ReactTable .rt-thead .rt-th {\n    word-break: break-word;\n    white-space: pre-line;\n}\n", ""]);
